import { useEffect, useMemo } from 'react';

function useUserCentricsCMP() {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const UC_UI = useMemo(() => (window as any).UC_UI, []);

  useEffect(() => {
    if (UC_UI) return UC_UI.closeCMP();
  }, [UC_UI]);

  const openConsentDialog = () => {
    if (UC_UI) {
      UC_UI.showSecondLayer();

      window.setTimeout(() => {
        const usercentricsRoot =
          document.getElementById('usercentrics-root')?.shadowRoot;

        const ucSaveButton = usercentricsRoot?.querySelector(
          '[data-testid=uc-save-button]',
        ) as HTMLElement | null;

        const ucAcceptAllButton = usercentricsRoot?.querySelector(
          '[data-testid=uc-accept-all-button]',
        ) as HTMLElement | null;

        if (ucSaveButton && ucAcceptAllButton) {
          ucSaveButton.addEventListener('click', function () {
            setTimeout(() => {
              UC_UI.closeCMP();
            }, 100);
          });
          ucAcceptAllButton.addEventListener('click', function () {
            setTimeout(() => {
              UC_UI.closeCMP();
            }, 100);
          });
        }
      }, 1000);
    }
  };

  return { UC_UI, openConsentDialog };
}

export { useUserCentricsCMP };
